import type { DocumentTypeVariable, DocumentTypeVariableCategory } from '@/document-types/domain/types/DocumentType';

export const BASE_VARIABLE_CATALOG: DocumentTypeVariableCategory[] = [
  {
    key: 'quote',
    label: 'Quote',
    variables: [
      { path: 'quote.number', label: 'Quote Number', type: 'string', example: 'Q-1001' },
      { path: 'quote.name', label: 'Quote Name', type: 'string', example: 'Foundation Pour – Building A' },
      { path: 'quote.date', label: 'Quote Date', type: 'date', example: '2026-04-17' },
      { path: 'quote.valid_until', label: 'Valid Until', type: 'date', example: '2026-05-17' },
      { path: 'quote.valid_days', label: 'Valid Days', type: 'number', example: '30' },
      { path: 'quote.status', label: 'Status', type: 'string', example: 'Draft' },
      { path: 'quote.po_number', label: 'PO Number', type: 'string', example: 'PO-44219' },
      { path: 'quote.description', label: 'Description', type: 'string', example: 'Site prep and foundation pour.' }
    ]
  },
  {
    key: 'customer',
    label: 'Customer',
    variables: [
      { path: 'customer.name', label: 'Account Name', type: 'string', example: 'Acme Construction' },
      { path: 'customer.address', label: 'Account Address', type: 'string', example: '1200 Industrial Pkwy, Denver, CO 80216' },
      { path: 'customer.city', label: 'Account City', type: 'string', example: 'Denver' },
      { path: 'customer.state', label: 'Account State', type: 'string', example: 'CO' },
      { path: 'customer.industry', label: 'Account Industry', type: 'string', example: 'General Contractor' },
      { path: 'customer.tags', label: 'Account Tags', type: 'string', example: 'VIP,Net-30' },
      { path: 'customer.email', label: 'Account Email', type: 'string', example: 'billing@acmecon.com' }
    ]
  },
  {
    key: 'contact',
    label: 'Contact',
    variables: [
      { path: 'contact.name', label: 'Contact Name', type: 'string', example: 'Jane Roberts' },
      { path: 'contact.email', label: 'Contact Email', type: 'string', example: 'jane@acmecon.com' },
      { path: 'contact.phone', label: 'Contact Phone', type: 'string', example: '(555) 201-3344' },
      { path: 'contact.title', label: 'Contact Title', type: 'string', example: 'Project Manager' }
    ]
  },
  {
    key: 'user',
    label: 'User',
    variables: [
      { path: 'user.name', label: 'Assigned User', type: 'string', example: 'Ben Whitaker' },
      { path: 'user.email', label: 'Assigned User Email', type: 'string', example: 'ben.whitaker@rapidservices.co' },
      { path: 'user.phone', label: 'Assigned User Phone', type: 'string', example: '(555) 201-7788' }
    ]
  },
  {
    key: 'opportunity',
    label: 'Opportunity',
    variables: [
      { path: 'opportunity.name', label: 'Opportunity Name', type: 'string', example: 'Acme Foundation 2026' },
      { path: 'opportunity.stage', label: 'Opportunity Stage', type: 'string', example: 'Negotiation' },
      { path: 'opportunity.expected_close_date', label: 'Expected Close Date', type: 'date', example: '2026-08-15' }
    ]
  },
  {
    key: 'jobsite',
    label: 'Job site',
    variables: [
      { path: 'jobsite.number', label: 'Job Site Number', type: 'number', example: '1' },
      { path: 'jobsite.name', label: 'Job Site Name', type: 'string', example: 'North Yard' },
      { path: 'jobsite.address', label: 'Job Site Address', type: 'string', example: '1200 Industrial Pkwy, Denver, CO 80216' },
      { path: 'jobsite.address_line1', label: 'Job Site Address Line 1', type: 'string', example: '1200 Industrial Pkwy' },
      { path: 'jobsite.address_line2', label: 'Job Site Address Line 2', type: 'string', example: 'Gate 4' },
      { path: 'jobsite.city', label: 'Job Site City', type: 'string', example: 'Denver' },
      { path: 'jobsite.state', label: 'Job Site State', type: 'string', example: 'CO' },
      { path: 'jobsite.postal_code', label: 'Job Site Postal Code', type: 'string', example: '80216' },
      { path: 'jobsite.contact_name', label: 'Job Site Contact', type: 'string', example: 'Sam Rivera' },
      { path: 'jobsite.contact_phone', label: 'Job Site Contact Phone', type: 'string', example: '(555) 201-3344' },
      { path: 'jobsite.contact_email', label: 'Job Site Contact Email', type: 'string', example: 'sam@acmecon.com' },
      {
        path: 'jobsites[]',
        label: 'All Job Sites',
        type: 'string',
        example: '1. North Yard, 2. South Yard',
        description: 'The selected job sites in order. A block using jobsite.* fields prints one numbered group per site from two sites up.'
      }
    ]
  },
  {
    key: 'scope',
    label: 'Scope',
    variables: [
      { path: 'scope.job_site_count', label: 'Job Site Count', type: 'number', example: '3' },
      { path: 'scope.phase_count', label: 'Phase Count', type: 'number', example: '2' },
      { path: 'scope.line_item_count', label: 'Line Item Count', type: 'number', example: '14' }
    ]
  },
  {
    key: 'totals',
    label: 'Total',
    variables: [
      { path: 'totals.subtotal', label: 'Subtotal', type: 'number', example: '$3,680.00' },
      { path: 'totals.discount_amount', label: 'Discount', type: 'number', example: '$184.00' },
      { path: 'totals.surcharge_amount', label: 'Surcharge', type: 'number', example: '$73.60' },
      { path: 'totals.tax_amount', label: 'Tax', type: 'number', example: '$258.72' },
      { path: 'totals.grand_total', label: 'Grand Total', type: 'number', example: '$3,828.32' }
    ]
  },
  {
    key: 'date',
    label: 'Date',
    variables: [{ path: 'today', label: "Today's Date", type: 'date', example: '2026-04-17' }]
  },
  {
    key: 'lineItems',
    label: 'Line Items',
    variables: [
      { path: 'lineItems.description', label: 'Line Item Description', type: 'string', example: 'Ready-mix concrete' },
      { path: 'lineItems.quantity', label: 'Quantity', type: 'number', example: '12.5' },
      { path: 'lineItems.unit_price', label: 'Unit Price', type: 'number', example: '145.00' },
      { path: 'lineItems.amount', label: 'Amount', type: 'number', example: '1812.50' }
    ]
  }
];

type RemoteWinningVariable = { variable: DocumentTypeVariable; categoryKey: string };

export function mergeCatalogs(
  remote: DocumentTypeVariableCategory[] | null | undefined,
  base: DocumentTypeVariableCategory[]
): DocumentTypeVariableCategory[] {
  const safeRemote = remote ?? [];

  const remoteByPath = new Map<string, RemoteWinningVariable>();
  for (const cat of safeRemote) {
    for (const v of cat.variables) {
      remoteByPath.set(v.path, { variable: v, categoryKey: cat.key });
    }
  }

  const categoryKeys = Array.from(new Set([...safeRemote.map((c) => c.key), ...base.map((c) => c.key)]));

  const result: DocumentTypeVariableCategory[] = [];
  for (const key of categoryKeys) {
    const remoteCat = safeRemote.find((c) => c.key === key);
    const baseCat = base.find((c) => c.key === key);

    const label = remoteCat?.label ?? baseCat?.label ?? key;

    const remoteVars = remoteCat?.variables ?? [];
    const remotePaths = new Set(remoteVars.map((v) => v.path));

    const baseVars = baseCat?.variables ?? [];

    const mergedVars: DocumentTypeVariable[] = [];
    const seen = new Set<string>();

    for (const v of remoteVars) {
      if (seen.has(v.path)) continue;
      mergedVars.push(v);
      seen.add(v.path);
    }

    for (const v of baseVars) {
      if (remoteByPath.has(v.path)) continue; // overridden by remote
      if (seen.has(v.path)) continue;
      mergedVars.push(v);
      seen.add(v.path);
    }

    // If remote overrode a variable that belongs to a different category in base,
    // it still wins by path; it will show up only under the remote category.
    for (const [path, winning] of remoteByPath.entries()) {
      if (winning.categoryKey !== key) continue;
      if (!remotePaths.has(path)) continue;
      if (seen.has(path)) continue;
      mergedVars.push(winning.variable);
      seen.add(path);
    }

    result.push({ key, label, variables: mergedVars });
  }

  return result;
}
